var React = require('react');

function PlaybuttonFilledMini (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","d":"M10.656 7 .628 13.928V.072z"}));
}

PlaybuttonFilledMini.defaultProps = {"fill":"none","viewBox":"0 0 11 14"};

module.exports = PlaybuttonFilledMini;

PlaybuttonFilledMini.default = PlaybuttonFilledMini;
